import React from "react";
import { XIcon } from "lucide-react";
import { Section, SectionHeading } from "./Section";
import { painPoints } from "../data/framework";
export function PainPointsSection() {
  return <Section tone="cream" labelledBy="pain-title" cta="I want a structured facelift learning system" data-id="element-242" data-mp="2wpkmejle44qr">
      <SectionHeading id="pain-title" title="Does this sound familiar?" sub="If you're a plastic surgeon or a qualified physician studying facelift surgery, you may recognize some of these situations." data-id="element-243" data-mp="2rpf0zl5preh4" />

      <ul className="mt-10 grid gap-x-10 md:grid-cols-2" data-id="element-244" data-mp="30q3hcmikxqx6">
        {painPoints.map(p => <li key={p.title} className="flex gap-4 border-b border-line py-6" data-id="element-245" data-mp="3fe7rv37haw4v">
            <span className="mt-1 grid h-8 w-8 shrink-0 place-items-center rounded-full bg-rose-soft text-rose" data-id="element-246" data-mp="3ag68sia1ywte">
              <XIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-247" data-mp="3oh0ir5cr15u6" />
            </span>
            <div data-id="element-248" data-mp="3kfnbcqu0cul5">
              <h3 className="text-[17px] font-bold leading-snug text-ink" data-id="element-249" data-mp="3kg6w0fb1lx2v">{p.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-250" data-mp="sw30p6l7k1zv">{p.body}</p>
            </div>
          </li>)}
      </ul>

      <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-251" data-mp="wy6ew2z9hkou">
        <p className="font-serif text-2xl font-bold italic text-navy" data-id="element-252" data-mp="11uok13yi7l1p">And it shouldn't have to feel so disorganized.</p>
        <p className="mt-4 text-[17px] leading-relaxed text-ink/90" data-id="element-253" data-mp="16vud52w2tabr">
          The problem isn't necessarily a lack of knowledge. Sometimes, the knowledge simply isn't organized into a repeatable learning
          system.
        </p>
        <p className="mt-3 text-[17px] font-semibold text-ink" data-id="element-254" data-mp="1km7jx1x8eizi">That's exactly why I created Facelift Blueprint™.</p>
      </div>
    </Section>;
}